import { CategoriaConfig } from 'app/main/categoria';
import { ClienteConfig } from './cliente';
import { CompraConfig } from './compra';
import { ConciliacaoConfig } from './conciliacao';
import ConfiguracaoConfig from './configuracao/configuracaoConfig';
import { ContaConfig } from './conta';
import { ContaReceberConfig } from './contareceber';
import { ContasPagarConfig } from './contaspagar';
import { ContratoConfig } from './contrato';
import { EmpresaConfig } from './empresa';
import EstoqueConfig from './estoque/EstoqueConfig';
import FaturamentoConfig from './faturamento/FaturamentoConfig';
import { FornecedorConfig } from './fornecedor';
import { GestaoEnvioConfig } from './gestaoenvio';
import { ImpostoConfig } from './imposto';
import { NotaFiscalConfig } from './nota-fiscal';
import { OrdemServicoConfig } from './ordemservico';
import { ProdutoConfig } from './produto';
import { PublicoConfig } from './publico';
import { AcompanharReguaCobrancaConfig } from './reguacobranca/AcompanharReguaCobranca';
import RelatoriosConfig from './relatorios/RelatoriosConfig';
import { ServicoConfig } from './servico';
import { TransferenciaConfig } from './transferencia';
import { TransportadoraConfig } from './transportadora';
import { VendaConfig } from './venda';
import { VendedorConfig } from './vendedor';
import { VisaoGeralConfig } from './visao-geral';

export default [
  VisaoGeralConfig,
  ContaConfig,
  ConfiguracaoConfig,
  CategoriaConfig,
  ClienteConfig,
  ProdutoConfig,
  GestaoEnvioConfig,
  ServicoConfig,
  CompraConfig,
  ContasPagarConfig,
  FaturamentoConfig,
  ContratoConfig,
  FornecedorConfig,
  ImpostoConfig,
  TransportadoraConfig,
  ConciliacaoConfig,
  VendaConfig,
  VendedorConfig,
  ContaReceberConfig,
  AcompanharReguaCobrancaConfig,
  EstoqueConfig,
  PublicoConfig,
  OrdemServicoConfig,
  NotaFiscalConfig,
  TransferenciaConfig,
  EmpresaConfig,
  RelatoriosConfig,
];
